import { render, staticRenderFns } from "./BaseDevice.vue?vue&type=template&id=39dea550&scoped=true&"
import script from "./BaseDevice.vue?vue&type=script&lang=js&"
export * from "./BaseDevice.vue?vue&type=script&lang=js&"
import style0 from "./BaseDevice.vue?vue&type=style&index=0&id=39dea550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dea550",
  null
  
)

export default component.exports